import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import EventDetail from '../events/EventDetail';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import { getBuilderConfigURL } from '../../../common/utils/builder-config-url-util';
import CustomLoader from '../../common/CustomLoader';
import { getCookie } from '../../home/app_util';

export class EventTab extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = { eventsBySearch: [], showLoader: false };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      const { projectId, version } = nextProps;
      this.props.actions.loadEvents({ projectId, version });
    }
    return true;
  }

  componentDidMount() {
    const { projectId, version, actions } = this.props;
    if (projectId) {
      actions.loadEvents({ projectId, version });
    }
  }

  handleRefresh() {
    const { projectId, version, actions } = this.props;
    this.setState({ showLoader: true });
    actions.loadEvents({ projectId, version }).then(() => this.setState({ showLoader: false }));
  }

  filterEventsBySearch = (event) => {
    const { value } = event.target;
    const { events } = this.props.editor;
    const eventsBySearch = findBySearchString('eventTitle', value, events);
    this.setState({ eventsBySearch });
  };

  listOfEventsToShow = (events) => {
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    let redirectUrl = getBuilderConfigURL();
    return events.map((event) => (
      <EventDetail
        key={event._id}
        event={event}
        version={this.props.version}
        projectId={this.props.projectId}
        redirectUrl={redirectUrl}
      />
    ));
  };

  render() {
    const { editor, projectId, version, isReadOnly } = this.props;
    const { events = [] } = editor;
    const totalEventCount = events.length;
    const { showLoader } = this.state;
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    let redirectUrl = getBuilderConfigURL();
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Events" className="padding-left-20">
              Events&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'default' }}
                data-tip="Total"
                title={'Total: ' + totalEventCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Events"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Events"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title={isReadOnly ? 'Read-only mode' : 'Add Event'}>
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip={isReadOnly ? 'Read-only mode' : 'Create New Event'}
                data-place="bottom"
                data-effect="solid"
                href={
                  isReadOnly
                    ? undefined
                    : `${redirectUrl}events/${version}/v/${projectId}/create?token=${token}`
                }
                onClick={(e) => {
                  if (isReadOnly) {
                    e.preventDefault();
                    return;
                  }
                }}
                style={{
                  opacity: isReadOnly ? 0.5 : 1,
                  cursor: isReadOnly ? 'not-allowed' : 'pointer',
                }}
              >
                <i className="wb webconnect-plus"></i> Add Event
              </a>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div id="events" className="column blocks is-abs--t-l gjs-one-bg blocks-open">
          <div className="gjs-blocks-cs gjs-one-bg gjs-two-color">
            <div className="gjs-block-categories">
              <div className="gjs-pn-panel height35 width100 position-relative">
                <div className="form-outline" style={{ padding: '10px' }}>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="&#xf55c; Eg: Login Event"
                    style={{ fontFamily: 'Arial, Webconnect' }}
                    onChange={this.filterEventsBySearch}
                  />
                </div>
                {this.state.eventsBySearch.length > 0 ? (
                  this.listOfEventsToShow(this.state.eventsBySearch)
                ) : events.length > 0 ? (
                  showLoader ? (
                    <CustomLoader loading={showLoader} />
                  ) : (
                    this.listOfEventsToShow(events)
                  )
                ) : (
                  ''
                )}
              </div>
              <div className="gjs-blocks-no-cat">
                <div className="gjs-blocks-c"></div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventTab);
